import React, {useState} from 'react';
import {FormGroup, Switch, InputGroup} from '@blueprintjs/core';

interface ThreadTSInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

const ThreadTSInput = ({
  value,
  onChange,
  disabled,
}: ThreadTSInputProps) => {
  const isChecked = (value || '').length > 0;
  const [checked, setChecked] = useState(isChecked);

  const onSwitchChange = (event: any) => {
    const _checked = event.target.checked;

    if (_checked === false) {
      onChange(''); // unset
    }
    setChecked(_checked);
  }

  return (
    <FormGroup label="" inline={true} className="slack-thread-ts">
      <Switch
        checked={checked}
        onChange={onSwitchChange}
        disabled={disabled}
      >
        Send message into another message thread.
      </Switch>
      {
        checked && (
          <InputGroup
            defaultValue={value || ''}
            onChange={(event: any) => onChange(event.target.value)}
            placeholder="{{ slack_1.thread }}"
            disabled={disabled}
          />
        )
      }
    </FormGroup>
  )
};

export default ThreadTSInput;
